module.exports = __webpack_public_path__ + "img/sdg9.9785ef43.svg";